import api from '../api';
const authUrl = process.env.REACT_APP_AUTH_API_URL;

const getProjectsFromUser = async (keycloakToken) => {
    try {
        const { data } = await api.get(
            `${authUrl}/projects`,
            {
                headers: {
                    'Authorization': `Bearer ${keycloakToken}`,
                },
            }
        );

        return data;
    } catch (error) {
        console.error("Error at getting projects from server:", error);
        throw new Error(error?.response?.data?.message || "Erro ao buscar projetos.");
    }
}

const getProjectByIdUserRole = async (projectId, keycloakToken) => {
    try {
        const { data } = await api.get(
            `${authUrl}/projects/user/${projectId}`,
            {
                headers: {
                    'Authorization': `Bearer ${keycloakToken}`,
                },
            }
        );

        return data;
    } catch (error) {
        console.error("Error at getting project by user from server:", error);
        throw new Error(error?.response?.data?.message || "Erro ao buscar projeto.");
    }
}

const getProjectById = async (projectId, keycloakToken) => {
    try {
        const { data } = await api.get(
            `${authUrl}/projects/${projectId}`,
            {
                headers: {
                    Authorization: `Bearer ${keycloakToken}`,
                },
            }
        );
        return data;
    } catch (error) {
        console.error("Error at getting project from server:", error);
        throw new Error(error?.response?.data?.message || "Erro ao buscar projeto.");
    }
}

const createProject = async (payload, keycloack) => {
    try {
        const projectDataContract = {
            name: payload.projectDataStore.projectData.title,
            focal_point_name: payload.projectDataStore.customerData.focalPoint,
            focal_point_email: payload.projectDataStore.customerData.focalPointEmail,
            focal_point_position: payload.projectDataStore.customerData.focalPointPosition,
            business_description: payload.projectDataStore.customerData.businessDescritive,
            project_type: payload.projectDataStore.projectData.type,
            start_date: payload.projectDataStore.projectData.startDate,
            end_date: payload.projectDataStore.projectData.endDate || null,
            goal: payload.projectDataStore.projectData.goal,
            business_context: payload.projectDataStore.projectData.businessContext,
            expected_result: payload.projectDataStore.projectData.expectedResults,
            target_public: payload.projectDataStore.projectData.targetPublic,
            company_id: payload.projectDataStore.customerData.company.id,
            indicators: payload.projectDataStore.impact.impactedBusinessIndicators,
            deliverables: payload.projectDataStore.impact.deliverables,
            project_summary: payload.projectSummary,
            last_user_updated: keycloack.idTokenParsed.name,
        }

        const { data } = await api.post(
            `${authUrl}/projects`,
            projectDataContract,
            {
                headers: {
                    Authorization: `Bearer ${keycloack.token}`,
                },
            }
        );
        return data;
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Erro ao criar projeto.");
    }
}

const updateProject = async (projectId, payload, keycloak) => {
    try {
        const projectDataContract = {
            name: payload.projectDataStore.projectData.title,
            focal_point_name: payload.projectDataStore.customerData.focalPoint,
            focal_point_email: payload.projectDataStore.customerData.focalPointEmail,
            focal_point_position: payload.projectDataStore.customerData.focalPointPosition,
            business_description: payload.projectDataStore.customerData.businessDescritive,
            project_type: payload.projectDataStore.projectData.type,
            start_date: payload.projectDataStore.projectData.startDate,
            end_date: payload.projectDataStore.projectData.endDate || null,
            goal: payload.projectDataStore.projectData.goal,
            business_context: payload.projectDataStore.projectData.businessContext,
            expected_result: payload.projectDataStore.impact.expectedResults,
            target_public: payload.projectDataStore.projectData.targetPublic,
            company_id: payload.projectDataStore.customerData.company.id,
            indicators: payload.projectDataStore.impact.impactedBusinessIndicators,
            deliverables: payload.projectDataStore.impact.deliverables,
            project_summary: payload.projectSummary,
            prompt_suggestions_business: payload.promptSuggestions,
        };

        const { data } = await api.patch(
            `${authUrl}/projects/${projectId}`,
            projectDataContract,
            {
                headers: {
                    Authorization: `Bearer ${keycloak.token}`,
                },
            }
        );
        return data;
    } catch (error) {
        console.error("Error updating project", error);
        throw new Error(error?.response?.data?.message || "Erro ao atualizar projeto.");
    }
}

const deleteProjectById = async (projectId, keycloakToken) => {
    try {
        const { data } = await api.delete(
            `${authUrl}/projects/${projectId}`,
            {
                headers: {
                    'Authorization': `Bearer ${keycloakToken}`,
                },
            }
        );
        return data;
    } catch (error) {
        console.error("Error to deleting project", error);
        throw new Error(error?.response?.data?.message || "Erro ao excluir projeto.");
    }
}

const favoriteProjectById = async (projectId, keycloakToken) => {
    try {
        const { data } = await api.put(
            `${authUrl}/projects/${projectId}/favorite`,
            null,
            {
                headers: {
                    'Authorization': `Bearer ${keycloakToken}`,
                },
            }
        );
        
        return data;
    } catch (error) {
        console.error("Error to favorite project", error);
        throw new Error(error?.response?.data?.message || "Erro ao atualizar projeto");
    }
}

const generateSummary = async (payload, keyloack) => {
    try {
        const projectDataContract = {
            name: payload.projectData.title,
            focal_point_name: payload.customerData.focalPoint,
            focal_point_email: payload.customerData.focalPointEmail,
            focal_point_position: payload.customerData.focalPointPosition,
            business_description: payload.customerData.businessDescritive,
            project_type: payload.projectData.type,
            start_date: payload.projectData.startDate,
            end_date: payload.projectData.endDate || null,
            goal: payload.projectData.goal,
            business_context: payload.projectData.businessContext,
            expected_result: payload.projectData.expectedResults,
            target_public: payload.projectData.targetPublic,
            company_id: payload.customerData.company.id,
            indicators: payload.impact.impactedBusinessIndicators,
            deliverables: payload.impact.deliverables,
            last_user_updated: keyloack.idTokenParsed.name,
            project_summary: 'Gerando resumo do projeto...',
        }

        const { data } = await api.post(
            `${authUrl}/projects/generate-summary`, 
            projectDataContract,
            {
                headers: {
                    'Authorization': `Bearer ${keyloack.token}`,
                },
            }
        );

        return data.summary;
    } catch (error) {
        console.error("Error to generate summary", error);
        throw new Error(error?.response?.data?.message || "Erro ao gerar resumo do projeto");
    }
}

const inviteMembers = async (projectId, emails, keycloakToken) => {
    try {
        const inviteData = {
            emails
        }
        const { data } = await api.post(
            `${authUrl}/projects/${projectId}/invite`,
            inviteData,
            {
                headers: {
                    'Authorization': `Bearer ${keycloakToken}`,
                    'Content-Type': 'application/json',
                },
            }
        );
        return data;
    } catch (error) {
        console.error('Error inviting members:', error);
        throw new Error(error?.response?.data?.message || 'Erro ao convidar membros.');
    }
}

const addUserToProject = async (projectId, name, email, keycloakToken) => {
    try {
        const { data } = await api.post(
            `${authUrl}/projects/${projectId}/add-user`,
            { name, email },
            {
                headers: {
                    'Authorization': `Bearer ${keycloakToken}`,
                    'Content-Type': 'application/json',
                },
            }
        );
        return data;
    } catch (error) {
        console.error('Error adding user to project:', error);
        throw new Error(error?.response?.data?.message || 'Erro ao adicionar usuário ao projeto.');
    }
}

const getProjectMembers = async (projectId, keycloakToken) => {
    try {
        const { data } = await api.get(
            `${authUrl}/projects/${projectId}/members`,
            {
                headers: {
                    'Authorization': `Bearer ${keycloakToken}`,
                },
            }
        );
        return data;
    } catch (error) {
        console.error('Error fetching project members:', error);
        throw new Error(error?.response?.data?.message || 'Erro ao buscar membros do projeto.');
    }
}

const removeProjectMember = async (projectId, email, keycloakToken) => {
    try {
        const { data } = await api.delete(
            `${authUrl}/projects/${projectId}/members`,
            {
                headers: {
                    'Authorization': `Bearer ${keycloakToken}`,
                },
                data: { email },
            }
        );
        return data;
    } catch (error) {
        console.error('Error removing project member:', error);
        throw new Error(error?.response?.data?.message || 'Erro ao remover membro do projeto.');
    }
}

export default { getProjectsFromUser, getProjectByIdUserRole, getProjectById, createProject, updateProject, deleteProjectById, favoriteProjectById, generateSummary, inviteMembers, addUserToProject, getProjectMembers, removeProjectMember };